export const getBasicInformation = state =>
  state.home.data && state.home.data.procurement
export const getStats = state => state.home.data && state.home.data.stats
export const getLastVendors = state =>
  state.home.data && state.home.data.homologated_vendors
